import { Box, Typography, Button } from '@mui/material'
import React, { useState } from 'react'
import { useGet } from '../../hooks/useApi';
import { useLocation } from 'react-router-dom';

const IndividualCategoriesNavbar = ({item, setCategory, category,to, addsIndex, setAddsIndex, categories, index}) => {
  const {pathname} = useLocation()
  const categoryId = item.id
  const { data: searchCatergories, error, isLoading } = useGet(`/api/GiftItemCategories/get-category/${categoryId}`);
  const getId = searchCatergories?.data?.id
  // console.log(getId)

  
const handleClick = (item) => {

  setCategory(item)
  if(index === categories?.length-1){
    setAddsIndex(categories[0]);
  }
  else{
  setAddsIndex(categories[index + 1])
  }

}

  return (
     <Button
            variant="contained"
            to={to}
            sx={{display:'flex', alignItems:'center', gap:1, textTransform:'none', color:`${category?.name === item.name||item?.categoryName?'rgba(255, 255, 255, 1)':'rgba(76, 70, 89, 1))'}`, boxShadow:'none', backgroundColor:`${category?.name === item.name ||item?.categoryName?'rgba(86, 4, 246, 1)':'rgba(251, 250, 255, 1)'}`, py:1, px:2, minWidth:'fit-content', borderRadius:'8px', ':hover': {
      color: 'rgba(86, 4, 246, 1)',
      fontWeight:600,
      boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
    }}}
            onClick={()=>handleClick(item)}
            >
                {item?.image && <img src={item?.image} alt="categories-image" style={{borderRadius:'50%'}}/>}
                <Typography>
                {pathname.includes('digital-courses')?
                item?.name:
                item?.description}
                </Typography>
                {/* <Typography>
                {item?.description}
                </Typography> */}
    </Button>
  )
}

export default IndividualCategoriesNavbar